<script lang="ts">
  import { building } from "$app/env";
  import { page } from "$app/state";
  import { m } from "#messages";
  import { loginHref } from "#lib/entrance/login.ts";
  import Button from "#lib/ui/Button.svelte";
  import IconDiscord from "~icons/simple-icons/discord";

  let { testId = "login" }: { testId?: string } = $props();

  let leaving = $state(false);
</script>

<Button
  variant="primary"
  size="lg"
  shape="round"
  href={loginHref(page.url, building)}
  loading={leaving}
  data-sveltekit-reload
  data-testid={testId}
  onclick={() => (leaving = true)}
>
  <IconDiscord aria-hidden="true" class="size-5 shrink-0" />
  {m.login_cta()}
</Button>
